import { useMemo } from 'react';
import { useAuthStore } from '../stores/authStore';
import { DEFAULT_LOCALIZATION } from './constants/localizationDefaults';
import { buildFormatters } from './localeFormat';

export * from './localeFormat';

/** React hook returning memoised formatter callbacks bound to the current tenant. */
export function useFormatters() {
  const settings =
    useAuthStore((s) => s.user?.localizationSettings) ?? DEFAULT_LOCALIZATION;
  return useMemo(() => buildFormatters(settings), [settings]);
}
